// extracted by mini-css-extract-plugin
export default {"container":"presentation_container__jUJIw","content":"presentation_content__iDFxu"};